module.exports = __webpack_public_path__ + "e2c17e7f17cd5a46692efab5cc0a91c4.png";